import { useEffect } from 'react';

const SUFFIX = 'Rudder AI';

export function usePageTitle(title?: string | null): void {
  useEffect(() => {
    document.title = title ? `${title} — ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = SUFFIX;
    };
  }, [title]);
}
